export default __webpack_public_path__ + "static/media/rss@2x.36e2a57f.png";